<template>
  <div>
    <div id="card-recent-transactions" class="d-flex justify-content-between mt-4">
      <div class="small card-title mb-0 font-weight-bold">{{ $t('WalletBalance.recentTransactions') }}</div>
      <router-link id="button-show-all-transactions" v-if="!showAsCardTransactions" :to="{name: 'wallet-transactions'}" class="small font-weight-bolder">
        {{
          $t('WalletBalance.showAllTransactions')
        }}
      </router-link>
    </div>
    <div class="list-group list-group-flush mx-n3 mb-n3" v-if="showAsCardTransactions">
      <CardTransactionRow v-for="(transaction, index) in transactions" :key="index" :transaction="transaction"/>
    </div>
    <div class="list-group list-group-flush mx-n3 mb-n3" v-else>
      <WalletTransactionRow v-for="(transaction, index) in transactions" :key="index" :transaction="transaction"/>
    </div>
  </div>
</template>

<script>

import WalletTransactionRow from '@shared/components/wallet/WalletTransactionRow'
import CardTransactionRow from '@shared/components/wallet/CardTransactionRow'

export default {
  components: { WalletTransactionRow, CardTransactionRow },
  props: ['transactions', 'showAsCardTransactions']
}
</script>
